import React from "react";
import { TopNavBar } from "./TopNavBar";
import { Footer } from "./Footer";

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="bg-surface text-on-surface font-body-md selection:bg-secondary-container selection:text-on-secondary-container min-h-screen flex flex-col">
      <TopNavBar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};
